"use client";

import { useEffect } from "react";
import { enforceDurableRetention } from "./durable-lead-store";

export function DurableRetentionGuard() {
  useEffect(() => {
    enforceDurableRetention();
  }, []);
  return null;
}
